import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./ComplaintAssignProductShow.css";
import { Button, Col, Form, Table } from "react-bootstrap";
import { getData, getDownloadDataExcel, postData } from "../../../../utils/api";
import ModalSave from "../../ModalSave";
import ModalComplaintSave from "../../ModalComplaintSave";
import ProductStatusChange from "../../modal/productStatusChange/ProductStatusChange";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ComplaintAssignProductShow = ({
  show,
  onHide,
  setErr,
  id,
  HistoryData,
  getAllData,
  id2,
}) => {
  const [data, setData] = useState([]);

  const [showChange, setShowChange] = useState(false);
  const [showData, setShowData] = useState("");

  const getAllProductData = async () => {
    {
      const res = await getData(
        `/complaint-management/complaints/get-assign-product/${id}`,
      );
      setData(res?.data);
    }
  };

  useEffect(() => {
    getAllProductData();
  }, [id]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleRemarkChange = async (id, value) => {
    const payload = {
      in_hand: value,
    };
    {
      const response = await postData(
        `/complaint-management/complaints/change-product-status/${id}`,
        payload,
      );

      if (response.success) {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          getAllProductData();
          setShowModal(0);
          // onHide();
        }, 1000);
      } else {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => setShowModal(0), 1000);
      }
    }

    // Example: update state / call API
    // updateRemark(id, value)
  };

  const HandleDownload = async () => {
    try {
      await getDownloadDataExcel(
        "/complaint-management/complaints/download-assign-product",
        { id: id },
        `assign Product List of complaint ${id2}`,
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Product Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-3">
          {data?.length > 0 && (
            <Col xl={3} lg={3} md={8} sm={6} className="my-auto">
              <Form.Label>
                <div className="Search-1 ">
                  <button
                    className="view_btn  btn btn-danger"
                    onClick={HandleDownload}>
                    Download data in Excel &nbsp;
                    <FontAwesomeIcon
                      icon="fa-solid fa-file-lines "
                      // className="pdf-icon"
                      // variant="success"
                    />
                  </button>
                </div>
              </Form.Label>
            </Col>
          )}

          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Product</th>
                  <th>Engineer</th>
                  <th>Issue Quantity</th>
                  {/* <th>Inhand Quantity</th> */}
                  <th>Applied Quantity</th>
                  <th>Return Quantity</th>
                  <th>Change product Status</th>
                </tr>
              </thead>

              <tbody>
                {data?.length > 0 ? (
                  data?.map((d, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>

                      <td>{d?.product?.name}</td>
                      <td>{d?.user?.name}</td>
                      <td>{d?.quantity || "-"}</td>
                      {/* <td>{d?.inhand_quantity || "-"}</td> */}
                      <td>{d?.applied_quantity || "-"}</td>
                      <td>{d?.return_quantity || "-"}</td>
                      <td>
                        {d?.status_change == 0 ? (
                          <Button
                            className="add-neww-btn btn-success"
                            onClick={() => {
                              setShowChange(true);
                              setShowData(d);
                            }}>
                            Change Status
                          </Button>
                        ) : (
                          "Status Updated"
                        )}
                      </td>
                      {/* <td>
                        {d?.in_hand == "Return" ? (
                          "Product Returned"
                        ) : (
                          <Form.Select
                            size="sm"
                            value={d?.in_hand || ""}
                            onChange={(e) =>
                              handleRemarkChange(d.id, e.target.value)
                            }>
                            <option value="">Select</option>
                            <option value="In Hand">In Hand</option>
                            <option value="Applied">Applied</option>
                            <option value="Return">Return</option>
                          </Form.Select>
                        )}
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      style={{ textAlign: "center", padding: "10px" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
      <ModalComplaintSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <ProductStatusChange
        show={showChange}
        onHide={() => setShowChange(false)}
        showData={showData}
        getAllProductData={getAllProductData}
        id={id}
      />
    </Modal>
  );
};

export default ComplaintAssignProductShow;
